// @ts-expect-error not typed yet

import { AB_SELECT_VALUE } from 'EmailData/constants/details/abEmailConstants';
import { isAutomatedAb } from 'EmailData/utils/details/abEmailUtil';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ABEmailCloneSelection({
  emailDetails,
  onSelect
}) {
  const hasABWinner = emailDetails.hasWinner();
  const [alertMessage, setAlertMessage] = useState(null);
  const masterKey = hasABWinner && isVersionWinner(emailDetails, AB_SELECT_VALUE.A) ? I18n.text('email-management.emailClone.cloneSidePanel.abOptions.CLONE_AB_MASTER_WINNER') : I18n.text('email-management.emailClone.cloneSidePanel.abOptions.CLONE_AB_MASTER');
  const variantKey = hasABWinner && isVersionWinner(emailDetails, AB_SELECT_VALUE.B) ? I18n.text('email-management.emailClone.cloneSidePanel.abOptions.CLONE_AB_VARIANT_WINNER') : I18n.text('email-management.emailClone.cloneSidePanel.abOptions.CLONE_AB_VARIANT');
  const emailCloneAbOptions = [{
    text: masterKey,
    title: masterKey,
    value: AB_SELECT_VALUE.A
  }, {
    text: variantKey,
    title: variantKey,
    value: AB_SELECT_VALUE.B
  }, {
    text: I18n.text('email-management.emailClone.cloneSidePanel.abOptions.CLONE_AB'),
    title: I18n.text('email-management.emailClone.cloneSidePanel.abOptions.CLONE_AB'),
    value: AB_SELECT_VALUE.AB,
    disabled: hasABWinner,
    tooltip: 'email-management.emailClone.cloneSidePanel.abOptions.abCloneDisabled'
  }];
  const onSelectAbOption = e => {
    const value = e.target.value;
    const content = value === AB_SELECT_VALUE.B ? emailDetails.getLastTestVariantEmail() : emailDetails.getLastTestPrimaryEmail();
    const abCloneOptionsValue = {
      willOverride: true,
      variantOnly: value !== AB_SELECT_VALUE.AB,
      contentId: content.id,
      version: value
    };
    onSelect(abCloneOptionsValue);
    switch (value) {
      case AB_SELECT_VALUE.A:
        setAlertMessage( /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: {
            Link: ({
              children
            }) => {
              return /*#__PURE__*/_jsx(Link, {
                external: true,
                href: content.getPreviewUrl(),
                children: children
              });
            }
          },
          message: "email-management.emailClone.cloneSidePanel.abOptions.versionAAlert_jsx"
        }));
        break;
      case AB_SELECT_VALUE.B:
        setAlertMessage( /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: {
            Link: ({
              children
            }) => {
              return /*#__PURE__*/_jsx(Link, {
                external: true,
                href: content.getPreviewUrl(),
                children: children
              });
            }
          },
          message: "email-management.emailClone.cloneSidePanel.abOptions.versionBAlert_jsx"
        }));
        break;
      case AB_SELECT_VALUE.AB:
        setAlertMessage( /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.emailClone.cloneSidePanel.abOptions.abAlert"
        }));
        break;
      default:
        break;
    }
  };
  return /*#__PURE__*/_jsx(FormControl, {
    marginBlockEnd: "400",
    "data-test-id": "clone-panel-ab-option-select",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email-management.emailClone.cloneSidePanel.abOptions.abEmailSelection"
    }),
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UISelect, {
        "data-test-id": "ab-option-select",
        itemComponent: tooltipWrappedOptions,
        onChange: onSelectAbOption,
        options: emailCloneAbOptions,
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.emailClone.cloneSidePanel.abOptions.selectVersion"
        })
      }), alertMessage && /*#__PURE__*/_jsx(Alert, {
        type: "info",
        marginBlockStart: "200",
        children: alertMessage
      })]
    })
  });
}
function isVersionWinner(emailDetails, version) {
  const automatedAb = isAutomatedAb(emailDetails);
  if (automatedAb) {
    return emailDetails.isEmailWinner(version);
  }
  return emailDetails.getWinningVariantType() === version;
}
function tooltipWrappedOptions({
  children,
  option
}) {
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "left",
    title: option.tooltip ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: option.tooltip
    }) : undefined,
    disabled: !option.disabled,
    children: children
  });
}